import * as React from 'react';
import { sharePhotoshootModalOpenVar } from 'uiState';
import Button from 'react-bootstrap/Button';
import './SharePhotoshootLink.scss';

interface SharePhotoshootLinkProps {
  children?: string;
  photoshootId: number;
}
const SharePhotoshootLink: React.FC<SharePhotoshootLinkProps> = ({
  photoshootId,
}: SharePhotoshootLinkProps) => (
  <Button
    variant="primary"
    onClick={(e: React.MouseEvent) => {
      e.preventDefault();
      sharePhotoshootModalOpenVar(photoshootId);
    }}
  >
    Jaa kuvakansio
  </Button>
);

export default SharePhotoshootLink;
